<template>
  <div>
    <div class="content_box row-column acea-row row-center-wrapper">
      <div
        :style="`backgroundImage: url(` + topHeaderImg + `)`"
        class="header_box row-column acea-row row-center-wrapper"
      >
        <div class="item">产品中心</div>
        <div class="item_small">-PRODUCT CONTER-</div>
      </div>
      <div class="acea-row row-column row-center-wrapper top_big_small_box">
        <div class="about_top_box acea-row row-middle">
          <div class="gary_text">{{ groupName }}</div>
        </div>
      </div>
      <div class="productList_content row-column acea-row row-center-wrapper">
        <productList :productList="productList"></productList>
      </div>
    </div>
  </div>
</template>
<script>
import productList from "@/components/productList2/index";
export default {
  name: "qualifications",
  data() {
    return {
      topHeaderImg: require("@/assets/productConter/topbg1.png"),
      groupName: "智能监控系列", //产品类型名称
      productList: [
        {
          name: "PS-JC",
          productImg: require("@/assets/productConter/goods/monitor_good1.png"),
          paramsImg: require("@/assets/productConter/params/PS-JC.png"),
          paramsminiImg: require("@/assets/productConter/params/mini/PS-JC.png"),
          size: "93.5*92*65",
          tableDataRight:[
            {technicalIndicators:"工作温度:",performanceDesc:'-20°℃~～85°C'},
            {technicalIndicators:"相对湿度:",performanceDesc:'≤80%'},
            {technicalIndicators:"工作电压Un:",performanceDesc:'100~～300V AC 50Hz'},
            {technicalIndicators:"可检测电流In:",performanceDesc:'0.1～100A'},
            {technicalIndicators:"过压报警:",performanceDesc:'>285V主5V(可调)'},
            {technicalIndicators:"欠压报警:",performanceDesc:'<160V士5V(可调)'},
            {technicalIndicators:"过流报警:",performanceDesc:'5OA(可调)'},
            {technicalIndicators:"自身功耗:",performanceDesc:'1W-5W,4G为5W'},
            {technicalIndicators:"电能计量精度:",performanceDesc:'0.5级'},
            {technicalIndicators:"电压测量精度:",performanceDesc:'0.1%'},
            {technicalIndicators:"电流测量精度:",performanceDesc:'0.5级'},
            {technicalIndicators:"环境温度监测精度:",performanceDesc:'0.1级'},
            {technicalIndicators:"线温温度监测精度:",performanceDesc:'0.5级'},
            {technicalIndicators:"蜂鸣器报警::",performanceDesc:'当监测到有烟雾气体或者线缆温度大于80摄氏度时蜂鸣器发出报警声。触发蜂鸣器报警的线缆温度值可以通过平台设置。任何触发的报警都会把信息发送到平台，平台再将信息发送到手机或者微信上。'}
          ],
          tableDataLeft:[
            {technicalIndicators:"电量统计:",performanceDesc:'保护器具有单相电能统计，电能统计可达l级精度以下。每月的第—'},
            {technicalIndicators:"实时显示:",performanceDesc:'数码可以显示电压，电流，有功功率，电量，环境温度和线缆温度。数码可以显示电压，电流，有功功率，电量，环境温度和线缆温度。和线绩温度。详细信息可通过查询按键查阅并显示。'},
            {technicalIndicators:"过流报警:",performanceDesc:'电流大于过流值或期间大于3倍过流值(视为短路)。过流触发报警值可以通过平台设置。'},
            {technicalIndicators:"欠压报警:",performanceDesc:'电压均低于16OV主5V(默认)，但均高于90V±5V，即认定为欠压。失压触发报警值可以通过平台设置。'},
            {technicalIndicators:"失压报警:",performanceDesc:'电压低于90V士5V，即认定为失压(主电网停电)。'},
            {technicalIndicators:"过压报警:",performanceDesc:'电压值大于280V士5V (默认)，即认定为过压。过压触发报警值可以通过平台设置。'},
            {technicalIndicators:"报警指示灯:",performanceDesc:'过流，过压，欠压有一个触发报警，故障指示灯会亮起。'},
            {technicalIndicators:"烟雾报警:",performanceDesc:'当检测到烟雾气体时,烟雾报警指示灯亮起。'},
            {technicalIndicators:"网络通讯:",performanceDesc:'本设备支持有线以太网TCP/IP网络通讯、4G cat.1 TCP网络通讯。当有4G信号时，4G指示灯亮起,当正常连接到服务器平台时，网络指示灯亮起,通讯灯亮起。'}
          ]
        }
      ]
    };
  },
  watch: {},
  components: {
    productList,
  },
  mounted: function () {},
};
</script>
<style scoped>
.content_box {
  width: 100%;

  background-color: #f3f3f3;
}
.content_box .header_box {
  width: 100%;
  height: 360px;
  background-size: 100% 100%;
  background-repeat: no-repeat;
}
.content_box .header_box .item {
  color: #fff;
  font-size: 40px;
}
.content_box .header_box .item_small {
  color: #fff;
  font-size: 23px;
}
.content_box .productList_content {
  padding: 20px 0px;
}
/* 关于我们 begin */
.top_big_small_box {
  margin-bottom: 0%;
  margin-top: 4%;
}
.top_big_small_box .about_top_box .gary_text {
  font-size: 42px;
  color: #555555;
}
.top_big_small_box .about_top_box .primary_color_text {
  margin-left: 10px;
  color: #313493;
  font-size: 42px;
  font-weight: bolder;
}

.top_big_small_box .top_text_box_two {
  color: #000000;
  font-size: 35px;
  margin-top: 10px;
  font-weight: bolder;
}

/* 关于我们 end */
.profile_content {
  color: #333333;
  font-size: 20px;
  width: 65%;
  line-height: 45px;
  margin-bottom: 40px;
}
</style>


// WEBPACK FOOTER //
// src/views/productConter/monitor.vue